import HttpClient from "./HttpClient";

class SavingRepository {
  private http = HttpClient.getInstance();

  /**
   * Solicitar una transferencia de ahorros.
   * @param authBasic Credenciales de autenticación en formato Basic.
   * @param formData Datos necesarios para la transferencia.
   */
  async setTransferenciaAplic(
    authBasic: string,
    formData: FormData
  ): Promise<any> {
    try {
      const response = await this.http.post(
        "/api/v1/documents/associates/transferencia",
        formData,
        {
          headers: {
            Authorization: `Basic ${authBasic}`,
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error al solicitar la transferencia:", error);
      throw error;
    }
  }
  async getEstadoAhorro(authBasic: string, formData: FormData): Promise<any> {
    try {
      const response = await this.http.post(
        "/api/v1/documents/associates/estadoahorro",
        formData,
        {
          headers: {
            Authorization: `Basic ${authBasic}`,
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error(
        "Error al solicitar el estado de cuenta de ahorros:",
        error
      );
      throw error;
    }
  }
}

export default new SavingRepository();
